import React from "react";
import { NotImplemented } from "pages/PayRoll/Shared/NotImplemented";

// Placeholder until Damage & Recovery is built. Reached from
// Payroll > Pay Inputs > Damage & Recovery in the sidebar flyout.
export const PayInputDamageAndRecovery = () => <NotImplemented title="Damage & Recovery" />;
